import React from 'react';
import { LimsNavIcon } from './LimsNavIcon';
import './RmFileDropZone.css';

export type RmFileDropZoneProps = {
  inputRef: React.RefObject<HTMLInputElement | null>;
  accept?: string;
  /** 已选预览（如 data URL） */
  previewSrc?: string;
  /** 无预览时的占位图 */
  placeholderSrc: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  hint?: string;
  'aria-label'?: string;
};

/**
 * 主题化图片上传区：虚线框 + 主色文案 + 全区域可点（原生 file 透明覆盖）。
 */
export function RmFileDropZone({
  inputRef,
  accept = 'image/*',
  previewSrc,
  placeholderSrc,
  onChange,
  title = '点击选择图片',
  hint = '支持 JPEG、PNG',
  'aria-label': ariaLabel = '上传图片'
}: RmFileDropZoneProps) {
  const src = previewSrc?.trim() ? previewSrc : placeholderSrc;
  return (
    <div className="rm-file-drop">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="rm-file-drop__input"
        onChange={onChange}
        aria-label={ariaLabel}
      />
      <div className="rm-file-drop__inner" aria-hidden>
        <img src={src} alt="" className="rm-file-drop__thumb" />
        <div className="rm-file-drop__copy">
          <span className="rm-file-drop__title">{title}</span>
          <span className="rm-file-drop__hint">{hint}</span>
        </div>
        <LimsNavIcon name="upload_file" sizePx={28} className="rm-file-drop__icon" />
      </div>
    </div>
  );
}
